import type { AppProps } from 'next/app';
import Head from 'next/head';
import { RecoilEnv, RecoilRoot } from 'recoil';

/* pagesで設定するプロパティ */
import { CustomPageProps } from '@/types/client/CutostomPageProps';

/* css定義 */
import { useEffect, useState } from 'react';
import '../styles/common/boilerplate.css';
import '../styles/common/all.css';
import '../styles/common/utility.css';
import '../styles/components/atoms.css';
import '../styles/components/molecules.css';
import '../styles/components/organisms.css';
import '../styles/components/template.css';
import '../styles/style_sp.css';
import '../styles/style.css';
import HistoryProvider from '@/providers/history';
import AxiosErrorHandleProvider from '@/providers/axiosError';

/** Mock起動対象環境判定 */
const API_MOCKING = process.env.NODE_ENV === 'development';

// Recoilの開発環境で Duplicate atom key 警告を抑制するための設定
if (process.env.NODE_ENV === 'development') {
  RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false;
}

/**
 * 画面描画処理
 * @param Component pages画面
 * @param pageProps 各pagesで設定したプロパティ
 * @returns
 */
const MyApp = ({
  Component,
  pageProps
}: AppProps<CustomPageProps>) => {
  /** Mock Service Worker起動処理 */
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    async function initMocks() {
      const {
        startMocking
      } = await import('../mocks/worker');
      await startMocking();
      setShouldRender(true);
    }
    if (API_MOCKING) {
      initMocks();
    } else {
      setShouldRender(true);
    }
  }, []);
  if (!shouldRender) {
    return null;
  }
  return <RecoilRoot>
      <AxiosErrorHandleProvider>
        <HistoryProvider>
          <Head>
            {pageProps.title ? <title>{pageProps.title} | MANOMAマイページ</title> : <title>MANOMAマイページ</title>}
            <meta name='viewport' content='width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no' />
          </Head>
          <Component {...pageProps} />
        </HistoryProvider>
      </AxiosErrorHandleProvider>
    </RecoilRoot>;
};
export default MyApp;